<template>
  <v-container>
    <v-app-bar
      flat
      color="primary"
      :aria-label="$t('components.transactions.packs.title')"
    >
      <v-toolbar-title>{{ $t('components.transactions.packs.title') }}</v-toolbar-title>
      <v-spacer />
    </v-app-bar>

    <v-data-table
      role="table"
      :aria-label="$t('components.transactions.packs.title')"
      :headers="headers"
      :items="transactionsFormatted"
      :loading="isLoading"
      loading-text="Loading... Please wait"
      no-results-text="No transactions was found"
      no-data-text="No data was found"
      item-key="orderId"
      class="elevation-1"
      color="secondary"
      sort-by="created"
      group-desc
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'fad fa-chevron-double-left',
        lastIcon: 'fad fa-chevron-double-right',
        prevIcon: 'fad fa-chevron-left',
        nextIcon: 'fad fa-chevron-right'
      }"
    >
      <template #progress>
        <v-progress-linear
          v-show="isLoading"
          :aria-busy="isLoading"
          color="accent"
          indeterminate
        />
      </template>

      <template #body="{ items }">
        <tbody>
          <tr
            v-for="item in items"
            :key="item.orderId"
          >
            <td>{{ item.orderId || '0' }}</td>
            <td>{{ item.charName || 'None' }}</td>
            <td>{{ item.packName || 'None' }}</td>
            <td>{{ item.perPackPrice || 0 }}</td>
            <td>{{ item.amount || 0 }}</td>
            <td>{{ item.totalPrice || 0 }}</td>
            <td>{{ item.status || 'Unknown' }}</td>
            <td>{{ item.created || '' }}</td>
            <td>
              <a
                v-if="item.pdfLink"
                target="_blank"
                class="link-accent"
                rel="noopener"
                :aria-label="`${$t('components.transactions.download')} (Order ${item.orderId})`"
                :href="item.pdfLink"
              >
                {{ $t('components.transactions.download') }}
              </a>
              <a
                v-else
                class="link-accent"
                target="_blank"
                rel="noopener"
                aria-disabled="true"
                :aria-label="`${$t('components.transactions.unavailable')} (Order ${item.orderId})`"
              >
                {{ $t('components.transactions.unavailable') }}
              </a>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getHeaders, toTransactions } from "@/utils/pack.transactions.utils";
import { mapGetters } from 'vuex';

export default {
  name: "TransactionsPacks",
  data() {
    return {
        transactions: [],
        headers: getHeaders(),
        isLoading: false
    }
  },
  computed: {
      ...mapGetters(['config']),

        transactionsFormatted() {
        // get our config for payments
        const config = this.config("shop") || {};
        // transform orders into our table data
        return toTransactions(
            config.statuses,
            config.currency,
            this.transactions
        );
    }
  },
  beforeMount() {
    this.isLoading = true;
    this.$api
      .getPackTransactioons()
      .then(transactions => {
        this.isLoading = false;
        this.transactions = transactions;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
};
</script>
